export default "/images/globe-icon-light-gray.png?b6b40ea393021eed07a97b519679795f";